// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BKFB","selected":"styles_selected__2w9z4"};